import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

function sortOptionSelected({ previousType, type }) {
    const property = {
        sort_name: type,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'select',
        category: 'react_search',
        label: 'sort_by',
        property,
    });

    amplitude.track('search_sorted', {
        updated_from: previousType,
        updated_to: type,
    });
}

export default { sortOptionSelected };
